export default function MistralAiIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "className">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <g clipPath="url(#clip0_19918_25340)">
        <path
          d="M7.38645 11.8451H3.69531L3.69703 8.15576H7.38832L7.38645 11.8451Z"
          fill="#1C1C1B"
        />
        <path
          d="M11.0739 15.5335H7.38281L7.38453 11.8442H11.0758L11.0739 15.5335Z"
          fill="#1C1C1B"
        />
        <path
          d="M11.0779 11.8451H7.38672L7.38852 8.15576H11.0798L11.0779 11.8451Z"
          fill="#1C1C1B"
        />
        <path
          d="M14.7686 11.8451H11.0774L11.0791 8.1558H14.7705L14.7686 11.8451ZM7.38809 8.15568H3.69688L3.69859 4.46631H7.38992L7.38809 8.15568ZM14.7704 8.15568H11.0792L11.081 4.46631H14.7722L14.7704 8.15568ZM3.69508 11.8451H0.00390625L0.005625 8.0944H3.69688L3.69508 11.8451Z"
          fill="#1C1C1B"
        />
        <path
          d="M3.69512 8.15568H0.00390625L0.00570313 4.46631H3.69695L3.69512 8.15568Z"
          fill="#1C1C1B"
        />
        <path
          d="M3.70055 4.52703H0.00933594L0.0110937 0.776367H3.70242L3.70055 4.52703ZM18.4653 4.46566H14.7741L14.7758 0.776367H18.4671L18.4653 4.46566ZM3.69508 15.5951H0.00390625L0.005625 11.783H3.69691L3.69508 15.5951Z"
          fill="#1C1C1B"
        />
        <path
          d="M3.69121 19.2238H0L0.00171875 15.5345H3.69297L3.69121 19.2238ZM18.4595 11.8451H14.7684L14.7701 8.1558H18.4613L18.4595 11.8451ZM18.4613 8.15568H14.7701L14.7718 4.46631H18.4632L18.4613 8.15568Z"
          fill="#1C1C1B"
        />
        <path
          d="M18.4568 15.5335H14.7656L14.7673 11.8442H18.4586L18.4568 15.5335Z"
          fill="#1C1C1B"
        />
        <path
          d="M18.4568 19.2228H14.7656L14.7673 15.4722H18.4586L18.4568 19.2228Z"
          fill="#1C1C1B"
        />
        <path
          d="M8.92035 11.8451H5.16797L5.16977 8.15576H8.92238L8.92035 11.8451Z"
          fill="#FF7000"
        />
        <path
          d="M12.6092 15.5344H8.91797L8.91969 11.7837H12.611L12.6092 15.5344Z"
          fill="#FF4900"
        />
        <path
          d="M12.6733 11.8451H8.85938L8.86117 8.15576H12.6752L12.6733 11.8451Z"
          fill="#FF7000"
        />
        <path
          d="M16.3658 11.8451H12.6133L12.615 8.15576H16.3676L16.3658 11.8451Z"
          fill="#FF7000"
        />
        <path
          d="M8.92434 8.15557H5.17188L5.17363 4.46631H8.92621L8.92426 8.15561L8.92434 8.15557ZM16.3682 8.15557H12.6156L12.6173 4.46631H16.37L16.3682 8.15557Z"
          fill="#FFA300"
        />
        <path
          d="M5.23012 11.9064H1.53906L1.54078 8.15576H5.23203L5.23012 11.9064Z"
          fill="#FF7000"
        />
        <path
          d="M5.23016 8.15557H1.53906L1.54078 4.42725H5.23203L5.23016 8.15557Z"
          fill="#FFA300"
        />
        <path
          d="M5.23406 4.46574H1.54297L1.54469 0.776367H5.23598L5.23406 4.46574ZM19.9988 4.5048H16.3077L16.3094 0.776367H20.0007L19.9988 4.5048Z"
          fill="#FFCE00"
        />
        <path
          d="M5.22621 15.6117H1.53516L1.53687 11.8442H5.22812L5.22621 15.6117Z"
          fill="#FF4900"
        />
        <path
          d="M5.22617 19.2231H1.53516L1.53688 15.5337H5.22812L5.22621 19.2231H5.22617Z"
          fill="#FF0107"
        />
        <path
          d="M19.9959 11.8451H16.3047L16.3065 8.15576H19.9977L19.9959 11.8451Z"
          fill="#FF7000"
        />
        <path
          d="M19.9958 8.15557H16.3047L16.3064 4.46631H19.9977L19.9958 8.15557Z"
          fill="#FFA300"
        />
        <path
          d="M19.9919 15.5726H16.3008L16.3025 11.8442H19.9938L19.9919 15.5726Z"
          fill="#FF4900"
        />
        <path
          d="M19.992 19.2231H16.3008L16.3026 15.5337H19.9938L19.992 19.2231Z"
          fill="#FF0107"
        />
      </g>
      <defs>
        <clipPath id="clip0_19918_25340">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
